import React, { useEffect, useState } from "react";
import TimeoutUtility from "../contexts/TimeoutUtility";
import {
  ScheduleComponent,
  Day,
  Week,
  Month,
  Agenda,
  Inject,
  Resize,
  DragAndDrop,
} from "@syncfusion/ej2-react-schedule";
// import { scheduleData } from "../data/dummy";
import { Header } from "../components";
import { useStateContext } from "../contexts/ContextProvider";
import { GetSaleOverview } from "../api";

const Calendar = () => {
  const { storeG, userObj } = useStateContext();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    async function fetchData() {
      if (storeG?.store_id && userObj) {
        const resp1 = GetSaleOverview(storeG.store_id);
        resp1.then(function (result) {
          setOrders(result.data || []);
        });
      }
    }
    fetchData();
  }, [storeG, userObj]);

  function getColorForName(name) {
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    const color = `hsl(${hash % 360}, 60%, 55%)`; // nice pastel
    return color;
  }

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 bg-white rounded-3xl">
      <Header category="Order" title="Order Calendar" />
      <ScheduleComponent
        height="calc(90vh - 196px)"
        selectedDate={new Date()}
        eventSettings={{
          dataSource: orders.map((order, i) => ({
            Id: order.so_id,
            Subject: `${order.customer} — ${order.quantity} ${order.unit} ${order.product}`,
            Customer: `${order.customer}`,
            Count: `${order.quantity}`,
            StartTime: new Date(order.req_date),
            EndTime: new Date(
              new Date(order.req_date).getTime() + 60 * 60 * 1000,
            ),
          })),
        }}
        eventRendered={(args) => {
          const name = args.data.Customer.split("—")[0].trim();
          const color = getColorForName(name);
          args.element.style.backgroundColor = color;
          args.element.style.borderColor = color;
          args.element.style.color = "white";

          const timeElement = args.element.querySelector(".e-time");
          if (timeElement) {
            timeElement.innerText = `SO#${args.data.Id} | ${args.data.Count} items`;
          }
        }}
        views={["Day", "Week", "Month", "Agenda"]}
        readonly={true}
        showQuickInfo={true}
      >
        <Inject services={[Day, Week, Month, Agenda, Resize, DragAndDrop]} />
      </ScheduleComponent>
    </div>
  );
};

export default Calendar;
